import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import type { GalleryData } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { PluginProps } from './../../ricos-types';
import { Loader, MediaItemErrorMsg } from './../../ui-components';

import styles from '../statics/styles/gallery-component-scss';
import { GalleryViewer } from '../viewer/gallery-viewer';

const renderMobileNativeLoader = ({ url }: $TSFixMe) =>
  url ? null : (
    <div className={styles.mobileNativeLoaderContainer}>
      <Loader type={'mini'} disableProgress />
    </div>
  );

export const Gallery: React.FC<PluginProps> = ({ settings, componentData, node }) => {
  const { error } = node.attrs;
  const { t } = useContext(RicosContext);
  const anchorTarget = '';
  const relValue = '';

  return (
    <>
      <GalleryViewer
        componentData={componentData as GalleryData}
        nodeId={node.attrs.id}
        settings={settings}
        anchorTarget={anchorTarget}
        relValue={relValue}
        itemOverlayElement={renderMobileNativeLoader}
      />
      {!error && node.attrs.loading && <Loader type={'medium'} />}
      {error && <MediaItemErrorMsg error={error} t={t} />}
    </>
  );
};
